import {
  type GetExamCenterProctorRequestByIdQuery,
  ExamCenterProctorRequestStep,
} from '@exam-center/graphql';
import { PROCTOR_REQUEST_STATUS_LABEL_MAP } from '@exam-center/proctor-request-management';
import { dayjs, formatDateTime } from '@shared/utils';

type ExamCenterProctorRequest =
  GetExamCenterProctorRequestByIdQuery['ecGetExamCenterProctorRequestById']['examCenterProctorRequest'];

export function getProctorRequestHeaderDetails(examCenterProctorRequest: ExamCenterProctorRequest) {
  const fullName = [
    examCenterProctorRequest.titleTh,
    examCenterProctorRequest.firstNameTh,
    examCenterProctorRequest.middleNameTh,
    examCenterProctorRequest.lastNameTh,
  ]
    .filter(Boolean)
    .join(' ');
  const status = PROCTOR_REQUEST_STATUS_LABEL_MAP[examCenterProctorRequest.step];
  const refCode = examCenterProctorRequest.refCode ?? '-';
  const examCenter = examCenterProctorRequest.examCenterCode;

  const lastModifiedAt = examCenterProctorRequest.editedAt
    ? formatDateTime(dayjs(examCenterProctorRequest.editedAt).toDate())
    : '-';

  const lastModifiedBy =
    examCenterProctorRequest.editedUser?.firstname && examCenterProctorRequest.editedUser?.lastname
      ? `${examCenterProctorRequest.editedUser.firstname} ${examCenterProctorRequest.editedUser.lastname}`
      : '-';

  const requestedAt =
    examCenterProctorRequest.requestedAt &&
    examCenterProctorRequest.step !== ExamCenterProctorRequestStep.Draft
      ? formatDateTime(dayjs(examCenterProctorRequest.requestedAt).toDate())
      : null;

  return { fullName, status, refCode, examCenter, lastModifiedAt, lastModifiedBy, requestedAt };
}
